import { CbhFeatureFlag, useCbhFlags } from "@src/appV2/FeatureFlags";
import { WorkerServiceEndpointMap } from "@src/utils/worker-service/worker-service.utils";
import { WorkerServiceAPIMapKey } from "@src/utils/worker-service/worker-service.utils";
import { useMemo } from "react";
import { useEffect } from "react";

export const useWorkerService = (): Record<string, boolean> => {
  const ldFlags = useCbhFlags();
  const workerServiceRemoteEndpointMap = ldFlags[CbhFeatureFlag.WORKER_SERVICE_MIGRATED_API_MAP];
  const isWorkerServiceEnabled = ldFlags[CbhFeatureFlag.WORKER_SERVICE_FOR_HCP_MOBILE_APP];

  const workerServiceConfig = useMemo<Record<string, boolean>>(() => {
    const endpointsMap = {};
    Object.keys(WorkerServiceEndpointMap).forEach((endpoint) => {
      const endpointPath = WorkerServiceEndpointMap[endpoint]?.path;
      const method = WorkerServiceEndpointMap[endpoint]?.method;
      const remoteKey = `${endpointPath}_${method}`;
      endpointsMap[remoteKey] =
        (workerServiceRemoteEndpointMap?.[remoteKey] && isWorkerServiceEnabled) ?? false;
    });
    return endpointsMap;
  }, [isWorkerServiceEnabled, workerServiceRemoteEndpointMap]);

  /**
   * This is pretty unusual, since it is an attempt to transfer state to localStorage,
   * which then is accessed outside of LD and hooks.
   * FIXME: eliminate this pattern, since it will likely cause unexpected bugs.
   * Instead, use the above config directly from this hook.
   */
  useEffect(() => {
    if (workerServiceConfig) {
      localStorage.setItem(WorkerServiceAPIMapKey, JSON.stringify(workerServiceConfig));
    }
  }, [workerServiceConfig]);

  return workerServiceConfig;
};
